import { render, staticRenderFns } from "./CrearBonos.vue?vue&type=template&id=2b9d0794&scoped=true&"
import script from "./CrearBonos.vue?vue&type=script&lang=js&"
export * from "./CrearBonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d0794",
  null
  
)

export default component.exports